import axios from 'axios'
import { get, size, debounce } from 'lodash'
import queryString from 'query-string'
import React from 'react'
import ReactPaginate from 'react-paginate'
import { Link } from 'react-router-dom'
import Select from 'react-select'
import { toast } from 'react-toastify'
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap'
import BaseList from '../../base/BaseList'
import AddButton from '../../components/buttons/AddButton'
import FilterBox from '../../components/FilterBox'
import Item from '../../components/Item'
import ListItemDetailed from '../../components/list/ListItemDetailed'
import Loading from '../../components/Loading'
import { API_HOST } from '../../consts'
import NavBreadCrumb from '../../containers/NavBreadCrumb'
import FiltroAvancadoItens from './FiltroAvancadoItens'
import ItemActionFeedbackModal from './ItemActionFeedbackModal'
import classnames from 'classnames';
import { Nav, NavItem, NavLink } from 'reactstrap';
import { TrackGoogleAnalyticsEvent } from '../../utils/googleAnalytics';
import { ClickAllObjects, ClickAllObjectsAction } from '../../utils/googleAnalytics/events/Itens/EventAllObjects'


class ListaItens extends BaseList {
  constructor(props) {
    super(props)
    this.expandAll = this.expandAll.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
    this.enviarRevisao = this.enviarRevisao.bind(this)
    this.params = {}
    this.api = `${API_HOST}${props.api}`
    this.state = {
      me: {},
      fetchingData: false,
      data: [],
      matriz: [],
      competencia: [],
      habilidade: [],
      dificuldade: [],
      page_size: 5,
      page: 1,
      collapsed: true,
      expandAllState: false,
      search: '',
      itensValidos: [],
      itensInvalidos: [],
      response: [],
      isAvancado: false,
      ordering: '-criado_em',
      filtros: [],
      itensInativados: {},
      filterBoxes: [],
      filterClick: false,
    }
  }

  removeConfirmationMessage = id => `Tem certeza que deseja remover o item / recurso pedagógico ${id}?`;
  criarTrilhaMessage = id => `Tem certeza que deseja criar uma atividade contendo os itens: ${id}?`;

  analytcsClick = (name, type) => {
    let label = "Click" + ": " + name;
    let category = ClickAllObjects + "_" + type;

    TrackGoogleAnalyticsEvent(
      category,
      ClickAllObjectsAction,
      label,
    );
  };

  componentDidMount() {
    this.fetchMe()
    const { location } = this.props
    const search = queryString.parse(location.search)
    if (search.id) {
      this.params = {
        id: search.id,
        ...this.params,
      }
    }
    if (search.page) {
      this.setState({ page: search.page }, this.fetchData)
    } else {
      this.fetchData()
    }
    const searchParams = new URLSearchParams(window.location.search);
    if (searchParams.get('Modal') === 'True') {

      this.setState({ openModal: 'filtroAvancado' })
    }
  }

  fetchDataCallback(results) {
    if (results.length > 0) {
      this.fetchPermissions()
    }
  }

  fetchMe() {
    const token = localStorage.getItem('token')
    axios
      .get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      })
      .then((response) => {
        this.setState({ me: response.data })
      })
      .catch((response) => console.error(response.error))
  }

  fetchData = async (loading = true, params) => {
    const { match } = this.props;
    const tipoId = match.params.id;

    let api = `${API_HOST}/itens/item?categoria=1`;

    if (tipoId) {
      api = `${API_HOST}/itens/item?categoria=${tipoId}`;
    }

    const { paramsFilterAtividades } = this.state;

    if (loading) {
      this.setState({ fetchingData: true });
    }

    return axios
      .get(api, {
        params: params ? params : paramsFilterAtividades || this.getParams()
      })
      .then((response) => {
        this.setState(
          {
            data: response.data.results,
            total: get(response, 'data.count', '-'),
            total_pages: get(response, 'data.total_pages', 0),
            fetchingData: false
          },
          () => {
            this.fetchDataCallback(response.data.results);
          }
        );
      })
      .catch((error) => {
        const status = get(error, 'response.status');
        if (status === 404) {
          const e = get(error, 'response.data.detail');
          toast.error(e);
        }

        this.setState({ fetchingData: false });
      });
  };

  expandAll() {
    this.setState({
      expandAllState: !this.state.expandAllState,
    })
  }

  changePage = (pagination) => {
    // const { location, history } = this.props
    this.setState({ fetchingData: true })
    const page = pagination.selected + 1
    this.setState({ page }, this.fetchData)
    // const search = queryString.stringify({
    //   ...queryString.parse(location.search),
    //   page,
    // })
    // history.push(`${location.pathname}?${search}`)
  }

  getDropdownList() {
    return [
      {
        id: 1,
        title: 'Imprimir',
        url: '/',
        key: 'action',
      },
      {
        id: 2,
        title: 'Exportar',
        url: '/',
        key: 'action',
      },
      {
        id: 3,
        title: 'Enviar para revisão',
        onClick: this.enviarRevisao,
        key: 'action',
      },
      {
        id: 4,
        title: 'Excluir',
        url: '/',
        key: 'action',
      },
    ]
  }

  fetchPermissions() {
    const { data } = this.state
    axios.get(`${API_HOST}/itens/item/permissions`, {
      params: {
        id: data.map(d => d.id).join(','),
      },
    })
      .then((response) => {
        const permissions = response.data

        this.setState({
          data: data.map(d => ({
            ...d,
            permissions: get(permissions, d.id),
          })),
        })
      })
  }

  renderPagination() {
    const { page, data, total_pages, fetchingData, total, page_size, } = this.state
    if (fetchingData) return null

    if (data.length > 0) {
      return (

        <div className="row" style={{ textAlign: 'center' }}>
          <div className="col-md-3">
            <Select
              matchPos="auto"
              className="filter-size"
              value={page_size}
              options={[
                { value: '5', label: '5 Objetos de aprendizagem' },
                { value: '10', label: '10 Objetos de aprendizagem' },
                { value: '25', label: '25 Objetos de aprendizagem' },
                { value: '50', label: '50 Objetos de aprendizagem' },
              ]}
              clearable={false}
              onChange={this.handleChangeNumberItens}
              searchable={false}
            />
          </div>
          <div className="col-md-3 col-lg-3 col-xs-3" style={{ fontSize: 12 }}>
            <p style={{ marginBottom: 5, marginTop: 10 }}>Mostrando <b>{data.length}</b> de <b>{total}</b> registros</p>
          </div>
          <div className="col-6">
            <ReactPaginate
              // className="pull-right"
              pageCount={total_pages}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              previousLabel="ANTERIOR"
              nextLabel="PRÓXIMA"
              onPageChange={pagination => this.changePage(pagination)}
              initialSelected={page}
              forcePage={page - 1}
              containerClassName="pagination"
              activeClassName="active"
              disabledClassName="disabled"
              disableInitialCallback
              breakLabel={<button className="disabled">. . .</button>}
            />
          </div>

        </div>

      )
    }

    return null
  }

  handleChangeNumberItens = (value) => {
    this.setState({ page_size: get(value, 'value') }, this.fetchData)
  }

  iniciarRevisao(item) {
    axios.post(`${API_HOST}/revisoes/revisao`, { item })
      .then((response) => {
        const { history } = this.props
        history.push(`/revisoes/${response.data.id}/edit`)
      })
      .catch((error) => {
        const status = get(error, 'response.status')
        if (status === 400) {
          const errors = get(error, 'response.data.item', [])
          toast.error((
            <ul>
              {errors.map(e => <li key={e}>{e}</li>)}
            </ul>
          ))
        }
      })
  }

  handleEditIntem = (itemId) =>{
    const {history} = this.props
    axios.get(`${API_HOST}/itens/item/should_edit?item_id=${itemId}`
    ).then(
      (res) =>{
        history.push(`/itens/${res.data.item_id}/dados`)
      }
    ).catch(
      (error) =>console.error(error)
    )
  }

  getActions = (item) => {
    const { match } = this.props;
    const tipoId = match.params.id;
    const { me } = this.state
    const id = get(item, 'id')
    const permissions = get(item, 'permissions') || []
    const deletePermission = me.logged_group.includes('ADMINISTRADOR') ? true : me.id !== get(item, 'criado_por_id') ? false : true
    const canEdit = me.groups.includes('ELABORADORSOMOS');

    const actions = []

    if (get(permissions, 'update') || canEdit) {
      actions.push((
        <div
          onClick={() => {this.handleEditIntem(id)}}
          className="btn btn-white mb-3"
          key="1"
        >
          <i className="fas fa-edit" />
        </div>
      ))
    }

    if (deletePermission && get(permissions, 'destroy')) {
      actions.push((
        <button key="2" className="btn btn-white mb-3" onClick={() => {
          this.analytcsClick(`Open Delete Modal Item ${id}`, 'Button: Objects Card');
          this.handleRemove(id, 'item');
        }}>
          <i className="fas fa-times" />
        </button>
      ))
    }


    return actions
  }

  removeItem(id) {
    axios.delete(`${API_HOST}/itens/item/${id}`)
      .then(() => {
        toast.success(`Objeto de Aprendizagem ${id} removido com sucesso.`)
        this.fetchData(false)
      })
  }

  duplicarItem() {
    const checkboxes = Array.from(document.querySelectorAll('[id^="checkbox-"]:checked'))
    const itens = checkboxes.map(c => c.id.split('-')[1])

    axios.get(`${API_HOST}/itens/item/${itens}/copy`)
      .then((response) => {
        toast.success(`Objeto de Aprendizagem ${itens} duplicado com sucesso.`)
        this.props.history.push(`/itens/${response.data.id}/dados`)
      })
  }

  doAction = ({ endpoint, modal, }) => {
    const checkboxes = Array.from(document.querySelectorAll('[id^="checkbox-"]:checked'))
    const itens = checkboxes.map(c => c.id.split('-')[1])

    if (itens.length === 0) {
      toast.error('Por favor, selecione um ou mais itens.')
      return
    }

    if (modal === 'removeConfirmation') {
      this.setState({
        openModal: modal,
        selectedForRemovalId: itens
      })
    } else if (modal === 'criarTrilha') {
      this.setState({
        openModal: modal,
        selectedForRemovalId: itens
      })
    } else {
      axios.post(`${API_HOST}${endpoint}`, { itens })
        .then((response) => {
          this.setState({
            itensValidos: response.data.itens_validos,
            itensInvalidos: response.data.itens_invalidos,
            selectedForRemovalId: itens,
            openModal: modal,
          })
          this.fetchData(false)
          Array.from(document.querySelectorAll('[id^="checkbox-"]:checked')).forEach((c) => {
            // eslint-disable-next-line
            c.checked = false
          })

          document.querySelector('#selecionar-todos').checked = false
        })
        .catch(() => {
          toast.error('Ocorreu um erro. Por favor, tente novamente.')
        })
    }
  }

  enviarRevisao() {
    this.doAction({
      endpoint: '/itens/item/enviar_revisao',
      modal: 'respostaEnviarRevisao',
    })
  }

  removeCheckItens = () => {
    this.doAction({
      endpoint: '/itens/item/removeConfirmation',
      modal: 'removeConfirmation',
    })
  }

  criarTrilha = () => {

    this.doAction({
      endpoint: '/itens/item/criarTrilha',
      modal: 'criarTrilha',
    })
  }

  inativar = () => {
    this.doAction({
      endpoint: '/itens/item/inativar',
      modal: 'inativar',
    })
  }

  getItemTitle(item) {
    const tipo = get(item, 'tipo.descricao')
    const areas_conhecimento = get(item, 'areas_conhecimento')
    let title = `Objeto de Aprendizagem ${item.id}`
    if (size(areas_conhecimento) > 0) {
      title += ` - ${areas_conhecimento.join(' - ')} `
    }
    if (tipo) {
      title += ` - ${tipo}`
    }
    return title
  }
  fetchExternalId(value) {
    this.setState({ fetchingData: true })
    axios.get(`${API_HOST}/itens/item?page=1&page_size=10&external_id=${value}&ordering=-criado_em`)
      .then((response) => {
        if (response.data.results.length > 0) {
          this.setState({ data: response.data.results, fetchingData: false })
        } else {
          this.setState({ fetchingData: false })
          toast.error('Não foram encontrados itens vinculados a esse código externo.')
        }
      })
  }

  debouncedFetchExternalId = debounce((value) => {
    this.fetchExternalId(value)
  }, 1000);

  renderList() {
    const { fetchingData, data, me } = this.state
    if (fetchingData) return <Loading />

    return data.map(item => (
      <ListItemDetailed
        me={me}
        key={item.id}
        title={this.getItemTitle(item)}
        status={{
          label: get(item, 'status.descricao', '-'),
          color: get(item, 'status.cor'),
        }}
        itemEnem={item.item_enem}
        description={[
          { label: 'Elaborador:', value: get(item, 'criado_por') || '-' },
          { label: 'Dificuldade presumida:', value: get(item, 'dificuldade.descricao', '-') },
        ]}
        // startCollapsed={expandAllState}
        startCollapsed
        atualizado_em={item.atualizado_em}
        versao={item.versao}
        actions={this.getActions(item)}
        id={item.id}
      >
        <Item item={item} />
      </ListItemDetailed>
    ))
  }

  renderAddButton() {
    const { match } = this.props;
    const tipoId = match.params.id;

    let buttonText = '';
    // Verifica o valor de tipoId e define o texto do botão de acordo
    switch (tipoId) {
      case '1':
        buttonText = 'Criar item';
        break;
      case '2':
        buttonText = 'Criar recurso';
        break;
      default:
        buttonText = 'Criar item';
        break;
    }
    const urlTo = `/itens/new/dados/tipo/${tipoId}`

    return (
      <div className="d-flex" style={{ marginTop: '15px' }}>
        <Link to={urlTo} onClick={() => { this.analytcsClick('Criar Objeto', 'Button: Create Object') }}>
          <AddButton icon="plus" title={buttonText} />
        </Link>
      </div>
    )
  }

  renderToolbar() {
    const { search, external_id } = this.state

    return (
      <div className="d-flex justify-content-between">
        <div className="d-flex" style={{ alignItems: 'center' }}>
          <label className="container-check-custom">
            <input
              type="checkbox"
              id="selecionar-todos"
              aria-label=""
              onChange={(e) => {
                this.selecionarTodos(e);
                if (e.target.checked) {
                  this.analytcsClick('Selecionar todos', 'Button: Select All');
                } else {
                  this.analytcsClick('Deselecionar todos', 'Button: Select All');
                }
              }}


            />
            <span className="checkmark" />
          </label>
          <div className="search mr-2" style={{ display: 'flex', flexDirection: 'row', }}>
            <input
              className="search-term"
              style={{ marginRight: '0.2rem', borderRadius: '40px', border: 'none', backgroundColor: '#E5E7EB' }}
              placeholder="Código"
              value={search}
              onBlur={(e) => { this.analytcsClick(`Código: ${e.target.value}`, 'Input: Filter Codes') }}
              onChange={(event) => {
                const { value } = event.target
                this.setState({ search: value })
                this.debouncedFetchData(value)
              }}
            />
            <input
              className="search-term"
              style={{ marginRight: '0.2rem', borderRadius: '40px', border: 'none', backgroundColor: '#E5E7EB' }}
              placeholder="Código externo"
              value={external_id}
              onBlur={(e) => { this.analytcsClick(`Código externo: ${e.target.value}`, 'Input: Filter Codes') }}
              onChange={(event) => {
                const { value } = event.target
                this.setState({ external_id: value })
                this.debouncedFetchExternalId(value)
              }}
            />
          </div>
        </div>
        <div >
          <div className="d-flex" style={{ alignItems: 'center' }}>
            <UncontrolledDropdown>
              <DropdownToggle caret style={{
                height: '40px',
                padding: '8px 16px',
                background: "#E4E4E4",
                borderRadius: "24px",
                border: "none",
                outline: "none",
                textTransform: "capitalize",
                display: 'flex',
                alignItems: 'center',
                fontFamily: 'Public Sans',
                fontSize: '16px',
                fontWeight: 700,
                lineheight: '24px',
                letterSpacing: '0em',
                textAlign: 'center',
                color: "#383838",
                display: 'flex',
                alignItems: 'center'
              }}
                onClick={() => { this.analytcsClick('Ações', 'Button: Action') }}
              >
                Ações
              </DropdownToggle>
              <DropdownMenu>
                {/* <DropdownItem>Imprimir</DropdownItem>
                <DropdownItem>Exportar</DropdownItem> */}
                <DropdownItem onClick={() => { this.enviarRevisao(); this.analytcsClick('Ações: Enviar para Revisão', 'Button: Action'); }}>Enviar para Revisão</DropdownItem>
                {this.hasPermission('itens.inativar_item') && <DropdownItem onClick={() => { this.inativar(); this.analytcsClick('Ações: Inativar', 'Button: Action'); }}>Inativar</DropdownItem>}
                <DropdownItem onClick={() => { this.criarTrilha(); this.analytcsClick('Ações: Criar Atividade', 'Button: Action'); }}>Criar Atividade</DropdownItem>
                <DropdownItem onClick={() => { this.removeCheckItens(); this.analytcsClick('Ações: Excluir', 'Button: Action'); }}>Excluir</DropdownItem>
                <DropdownItem onClick={() => { this.duplicarItem(); this.analytcsClick('Ações: Duplicar', 'Button: Action') }}>Duplicar</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>

            <button
              type="button"
              onClick={() => {
                this.analytcsClick('Filtro', 'Button: Filter')
                this.toggleModal('filtroAvancado')
              }}
              style={{
                width: '90px',
                fontFamily: 'Public Sans',
                fontSize: '16px',
                fontWeight: 700,
                lineHeight: '24px',
                letterSpacing: '0em',
                textAlign: 'center',
                display: 'flex',
                alignItems: 'center',
                padding: '8px, 0px, 8px, 0px',
                borderRadius: '24px',
                border: 'none',
                height: '40px',
                background: "#E4E4E4",
              }}>
              <i className="icon-Filter"
                style={{
                  marginRight: '6px',
                  fontSize: '24px',
                  fontWeight: 400,
                  lineHeight: '24px',
                  letterSpacing: '0em',
                  textAlign: 'center',
                }}
              /> Filtro
            </button>

            {this.renderOrderingSelect()}
            {this.renderAddButton()}
          </div>
        </div>

      </div>
    )
  }

  toggleModal(name) {
    const { openModal } = this.state
    this.setState({ openModal: openModal === name ? null : name })
  }

  limparFiltros = () => {
    this.setState({ isAvancado: false })
    this.params = {}
    const { history, location } = this.props
    history.push(location.pathname)
    this.fetchData()
  }

  renderBreadcrumb() {
    const { title } = this.props
    return <NavBreadCrumb currentPath={title} hasBackslash={false} />
  }

  buscarItens = (v) => {
    const values = { ...v }
    if (Array.isArray(values.palavras_chave) && values.palavras_chave.length > 0) {
      values.palavras_chave = values.palavras_chave.map(item => item.value).join('|')
    }
    this.params = { ...values }
    this.fetchData()
  }

  selecionarTodos(event) {
    const { checked } = event.target
    Array.from(document.querySelectorAll('[id^="checkbox-"]')).forEach((checkbox) => {
      // eslint-disable-next-line
      checkbox.checked = checked
    })
  }

  updateFilterBoxes = (filterBoxes) => {
    this.setState({ filterBoxes })
    this.setState({ filterClick: false })
  }

  removeFilter(field) {
    this.setState({ filterToRemove: field })
  }

  renderCategoryFilter() {
    const { match, history } = this.props;
    const tipoId = match.params.id;

    return (
      <div className='container mb-3'>
        <Nav tabs>
          <NavItem>
            <NavLink
              className={classnames({
                active: tipoId === '1'
              })}
              onClick={async () => {
                await history.push('/itens/tipo/1')
                this.fetchData();
              }}
            >
              Banco de Itens
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames({
                active: tipoId === '2'
              })}
              onClick={async () => {
                await history.push('/itens/tipo/2')
                this.fetchData();
              }}
            >
              Recursos pedagógicos
            </NavLink>
          </NavItem>
        </Nav>
      </div >
    )
  }

  render() {
    const {
      openModal,
      itensValidos,
      itensInvalidos,
      filterBoxes,
      filterToRemove,
      filterClick,
    } = this.state;

    return (
      <div>
        {/* {this.renderBreadcrumb()} */}
        {this.renderCategoryFilter()}
        <div className="container">
          {this.renderToolbar()}
          {filterBoxes && filterBoxes.length > 0 && (
            filterBoxes.map(d => (
              <FilterBox
                key={d.field}
                onClick={() => {
                  this.removeFilter(d.field);
                  this.setState({ filterClick: true });
                }}
                className="mr-1 mb-1"
                {...d}
              />
            ))
          )}
          {filterBoxes && filterBoxes.length > 0 && (
            <div className="row">
              <div className="col-2">
                <button
                  className="btn btn-white mb-3"
                  onClick={this.limparFiltros}
                >
                  <i className="fas fa-eraser" /> Limpar todos os filtros
                </button>
              </div>
            </div>
          )}
          {this.renderList()}
          {this.renderPagination()}
          {this.renderRemoveConfirmationModal()}
          {this.renderCriarTrilha()}
          <FiltroAvancadoItens
            tipoId={this.props.match.params.id}
            isOpen={openModal === 'filtroAvancado'}
            toggle={() => this.toggleModal('filtroAvancado')}
            buscarItens={this.buscarItens}
            updateFilterBoxes={this.updateFilterBoxes}
            filterToRemove={filterToRemove}
            filterClick={filterClick}
          />
          <ItemActionFeedbackModal
            isOpen={openModal === 'respostaEnviarRevisao'}
            toggle={() => this.toggleModal('respostaEnviarRevisao')}
            valid={itensValidos}
            invalid={itensInvalidos}
            title="Enviar Objetos de Aprendizagem para revisão"
            validTitle="Objetos de Aprendizagem enviados"
            invalidTitle="Objetos de Aprendizagem que não puderam ser enviados"
          />
          <ItemActionFeedbackModal
            isOpen={openModal === 'inativar'}
            toggle={() => this.toggleModal('inativar')}
            valid={itensValidos}
            invalid={itensInvalidos}
            title="Inativar Objetos de Aprendizagem"
            validTitle="Objetos de Aprendizagem inativados"
            invalidTitle="Objetos de Aprendizagem que não puderam ser inativados"
          />
        </div>
      </div>
    )
  }
}

export default ListaItens
